import Box from '@mui/material/Box';
import { ReactNode } from 'react';
import NavBar, { Navigation } from '../navigation/NavBar';
import classes from './Page.module.scss';
import Paper from './Paper';

export default function Page({
  children,
  navigation,
  surface = 'paper',
}: {
  children: ReactNode;
  navigation?: false | Navigation;
  surface?: 'empty' | 'paper' | 'transparent';
}) {
  return (
    <div className={classes.root}>
      {navigation !== false && <NavBar navigation={navigation} />}

      {surface === 'paper' && <Paper>{children}</Paper>}
      {surface === 'transparent' && <Box mx={3}>{children}</Box>}
      {surface === 'empty' && children}
    </div>
  );
}
